<app-compliance-nav [activeMenuItem]="'adr'"></app-compliance-nav>

<mat-card class="content-card">

  <div fxLayout="column">
    <div fxLayout="row wrap" fxLayoutGap="30px" fxLayoutAlign="flex-start center">


      <mat-form-field>
        <mat-label>Brand</mat-label>
        <mat-select [formControl]="companySelect" (selectionChange)="onCompanyChange()">
          <mat-option  *ngFor="let company of companies"
                      [value]="company.id">
            {{company.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- #endregion WebId status select -->

      <!-- #region star-end data, date filters, search -->



      <!-- #endregion star-end data, date filters, search -->


      <div fxLayout="row wrap" fxLayoutGap="10px" *ngIf="table">
        <mat-form-field style="width: 400px;" class="search-field">
          <input #searchField matInput (keydown.enter)="onSearch(searchButton.disabled)" placeholder="Search"
                 [(ngModel)]="table.filters.str">
        </mat-form-field>
        <button #searchButton mat-icon-button (click)="onSearch()">
          <mat-icon>search</mat-icon>
        </button>
        <button mat-icon-button (click)="table.clearFilter()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>

  </div>

  <app-mat-table-generator #table
      tableName = "customerAddressTable"
      [useEmbededFilter]="false"
      [columns] ="columns"
      [dataSource] ="dataSource"
      [viewLink]="getViewLink"
      [deleteEnabled]="deleteEnabled()"
      [multiselectEnabled]="deleteEnabled()"
  >
  </app-mat-table-generator>
</mat-card>
